import React, { useEffect, useState } from "react";
import { CancelOrder, CancelOrderByAdmin, createdPass, PostOrderAdmin } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import { PostUserAdmin } from "../../../../services/UserService";
import { ActiveType } from "../../../../models/Login";
import { PostPartnerAdmin } from "../../../../services/PartnerService";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useAddPartnerAdmin(props: { reload?: () => void }) {
	const { openAlertDialog } = useAlertDialog();
	const addPartnerAd = async (
		name: string,
		email: string,
		phone: string,
		password: string,
		address: string,
		addressText: string,
		note: string,
		phonePrefix: string,
		rateReview: string,
		reviewCount: string,
		displayName: string,
		displayAddress: string,
		emailPartner: string,
		isSelect: boolean,
		stationCom?: number,
		minimumPayout?: number,
		pubRate?: number,
		lat?: string,
		long?: string,
		destinationId?: string
	) => {
		try {
			await PostPartnerAdmin(
				name,
				email,
				phone,
				password,
				address,
				addressText,
				note,
				phonePrefix,
				rateReview,
				reviewCount,
				displayName,
				displayAddress,
				emailPartner,
				isSelect,
				stationCom,
				minimumPayout,
				pubRate,
				lat,
				long,
				destinationId
			);
			openAlertDialog?.(AlertType.Success, "Add successfully!", () => {
				props.reload?.();
			});
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "An error has occurred!");
		}
	};

	return {
		addPartnerAd,
	};
}
